import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useExtratoFiscal = ({ dadosOs }) => {
  const [extrato, setExtrato] = useState({});
  const [listaReclamacao, setListaReclamacao] = useState([]);
  const [patCriticado, setPatCriticado] = useState([]);
  const [patNaoCriticado, setPatNaoCriticado] = useState([]);

  const { request: requestExtrato, data: dataExtrato, errors: errorsExtrato } = useApiClient();

  useEffect(() => {
    requestExtrato(apiRoutes.extratofiscal.extrato.consulta, { ie: dadosOs?.inscricaoEstadual });
  }, [requestExtrato, dadosOs]);

  useEffect(() => {
    if (dataExtrato && dataExtrato.result) {
      setTimeout(() => {
        setExtrato(dataExtrato.result);
      }, 1000);
    }
    if (errorsExtrato) {
      toast.error(errorsExtrato.message);
    }
  }, [dataExtrato, errorsExtrato]);

  const {
    dadosContribuinte,
    obrigacoesAdvertencias,
    obrigacoesPendencias,
    obrigacoesSuspensas,
    debitosVencidos,
    debitoSuspenso,
    debitoAcordoCejuscFiscal,
    processoAdministrativoTributario,
    debitosVencer,
    debitosAcaoFiscalCobranca,
    dadosCrecenciamento,
    ocorrenciasFiscais,
    liminarLiberacao,
    regimeEspecial,
    parcelamento,
    pedidosVirtuais,
    itensDividaAtiva,
    debitosNaoPagosDividaAtiva,
  } = extrato;

  const { request: requestReclamacao, data: dataReclamacao, errors: errorsReclamacao } = useApiClient();

  useEffect(() => {
    if (dadosContribuinte && dadosContribuinte?.cnpjCnpf) {
      requestReclamacao(apiRoutes.nfp.reclamacao.listarReclamacao, { cnpj: dadosContribuinte?.cnpjCnpf });
    }
  }, [requestReclamacao, dadosContribuinte]);

  useEffect(() => {
    if (dataReclamacao) {
      setTimeout(() => {
        setListaReclamacao(dataReclamacao.result);
      }, 1000);
    }
    if (errorsReclamacao && errorsReclamacao.message !== "Reclamação não existe") {
      toast.error(errorsReclamacao.message);
    }
  }, [dataReclamacao, errorsReclamacao]);

  if (processoAdministrativoTributario?.length > 0) {
    setPatCriticado(processoAdministrativoTributario.filter((processo) => processo.fg_critica === "S") ?? null);
  }
  if (extrato.processoAdministrativoTributario?.length > 0) {
    setPatNaoCriticado(
      extrato.processoAdministrativoTributario.filter((processo) => processo.fg_critica === "N") ?? null,
    );
  }

  const { request: requestDownload, data: dataDownload, errors: errorDownload } = useApiClient();

  const handleImprimirExtrato = useCallback(
    (ie, cnpj) => {
      requestDownload(apiRoutes.extratofiscal.extrato.imprimirExtrato, { ie, cnpj });
    },
    [requestDownload],
  );

  const handleDownload = useCallback(() => {
    if (dataDownload) {
      const file = new Blob([dataDownload], { type: "application/pdf" });

      setTimeout(() => {
        const url = URL?.createObjectURL(file);
        window.open(url, "_blank", "width=800,height=800").print();
      }, 1000);
    }
    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload]);

  useEffect(() => {
    handleDownload();
  }, [handleDownload]);

  return {
    dadosContribuinte,
    listaReclamacao,
    obrigacoesAdvertencias,
    obrigacoesPendencias,
    obrigacoesSuspensas,
    debitosVencidos,
    debitoSuspenso,
    debitoAcordoCejuscFiscal,
    patCriticado,
    debitosVencer,
    debitosAcaoFiscalCobranca,
    dadosCrecenciamento,
    ocorrenciasFiscais,
    liminarLiberacao,
    regimeEspecial,
    patNaoCriticado,
    parcelamento,
    pedidosVirtuais,
    itensDividaAtiva,
    debitosNaoPagosDividaAtiva,
    handleImprimirExtrato,
  };
};

export default useExtratoFiscal;
